module.exports = "<header> <ul class=nav-list> <li v-for=\"item in items\"> <a href=\"{{ item.url }}\">{{ item.nav }}</a> </li> </ul> </header>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav.vue
 ** module id = 8
 ** module chunks = 0
 **/